import { KeyRound } from 'lucide-react'

import { SplitsAvatar } from '~/components/SplitsAvatar'
import { Tooltip } from '~/components/component-library'
import { Timestamp } from '~/components/component-library/Timestamp'
import { OrgEOASigner } from '~/types'
import { EvmAddress } from '~/utils/address'
import { shortenAddress } from '~/utils/addresses'
import { cn } from '~/utils/tailwind-utils'

export const EoaIconWithTooltip = ({
  signer,
  iconOnly = false,
}: {
  signer: OrgEOASigner
  iconOnly?: boolean
}) => {
  const { address, name, createdAt, lastVerifiedAt } = signer
  const activityTimestamp = lastVerifiedAt ?? createdAt
  const activityLabel = lastVerifiedAt ? 'Last verified' : 'Added'

  return (
    <Tooltip
      content={
        <div className="flex max-w-48 flex-col gap-0.5 leading-tight">
          <span className="w-full truncate text-left text-xs font-medium">
            {name ?? shortenAddress(address)}
          </span>
          {name && (
            <span className="w-full truncate text-left text-xs text-secondary">
              {shortenAddress(address)}
            </span>
          )}
          {activityTimestamp && (
            <span className="text-xs text-secondary">
              {activityLabel}{' '}
              <Timestamp
                timestamp={activityTimestamp}
                type="relative"
                abbreviate
                showTooltip={false}
              />
            </span>
          )}
        </div>
      }
      className={cn(
        'relative flex h-6 w-6 items-center justify-center rounded-full border-[2px] border-white transition-[margin] duration-150 dark:border-black',
        {
          'bg-gray-200 dark:bg-gray-800': iconOnly,
          'overflow-hidden': !iconOnly,
        },
      )}
    >
      {iconOnly ? (
        <KeyRound size={12} className="text-secondary" />
      ) : (
        <SplitsAvatar address={EvmAddress.format(address)} size={20} />
      )}
    </Tooltip>
  )
}
